
import { defineComponent } from "vue";

export default defineComponent({
  name: "ImagePopup",
  props: {
    src: {
      type: String,
      required: true
    }
  },
  setup(_, { emit }) {
    const close = () => {
      emit("close");
    };

    return {
      close
    };
  }
});
